import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';
import {
  Box, Button, Container, SvgIcon, Typography,
} from '@mui/material';
import Erro404 from '@assets/errors/error-404.png';
import styles from './404.module.scss';

const ForbiddenPage = () => (
  <>
    <Helmet>
      <title>
        403
      </title>
    </Helmet>
    <Box
      component="main"
      className={styles.main_area_box}
    >
      <Container maxWidth="md">
        <Box
          className={styles.column_layout_box}
        >
          <Box
            className={styles.under_development_container}
          >
            <img
              alt="Under development"
              src={Erro404}
              className={styles.under_development_image}
            />
          </Box>
          <Typography
            align="center"
            sx={{ mb: 3 }}
            variant="h3"
          >
            403: Forbidden
          </Typography>
          <Typography
            align="center"
            color="text.secondary"
            variant="body1"
          >
            You don&apos;t have access to this resource.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            startIcon={(
              <SvgIcon fontSize="small">
                <ArrowLeftIcon />
              </SvgIcon>
         )}
            sx={{ mt: 3 }}
            variant="contained"
          >
            Go back to dashboard
          </Button>
        </Box>
      </Container>
    </Box>
  </>
);

export default ForbiddenPage;
